export default () => jQuery(($) => {
	const scroll_area = $('.scroll_progress_indicator');
	scroll_area.prepend('<div class="scroll_progress_indicator--bar"><span>&nbsp;</span></div>');

	$(window).scroll(function () {
		const viewport_h = $(window).height();
		const scroller_h = scroll_area.height();
		const bar_h = $('body.admin-bar') ? 32 : 0;
		const top_position = $(document).scrollTop() + bar_h - scroll_area.offset().top;
		if (top_position > 0) {
			const top_fraction = Math.min( ( top_position / scroller_h ), 1);
			const pct = Math.min( ( ( ( top_position + ( viewport_h * top_fraction ) ) / scroller_h ) * 100 ).toFixed(2) , 100);
			$('.scroll_progress_indicator--bar span').css('width', pct + '%');
		} else {
			$('.scroll_progress_indicator--bar span').css('width', 0);
		}
	});
});
